// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/debug/AdminConfig.css
// module id = 2006
// module chunks = 0